import { instance } from "api/apiBase";
import { jwt } from "api/jwt";

const api = {
  login: async (email: string, password: string) => {
    const response = await instance.post("/portal/v1/auth/jwt/sign_in", {
      email,
      password
    });
    jwt.setTokens({
      access_token: response.data.access_token,
      refresh_token: response.data.refresh_token
    });
    return response.data;
  },
  checkAuth: async () => {
    await jwt.ensureAccessToken();
    return (await instance.get("/portal/v1/auth/jwt/me")).data;
  },
  logout: async () => {
    try {
      await instance.delete("/portal/v1/auth/jwt/sign_out");
    } finally {
      jwt.clearTokens();
    }
  },
  resetPassword: async (email: string) => {
    return (await instance.post(`/portal/v1/reset_password`, { email })).data;
  },
  sso: async (email: string, from?: string) => {
    return (await instance.post("/portal/v1/sso/auth", { email, from })).data;
  }
};

export const logout = async () => {
  try {
    await instance.delete("/portal/v1/auth/jwt/sign_out");
  } finally {
    jwt.clearTokens();
  }
};

export const changePassword = async (
  oldPassword: string,
  newPassword: string
) => {
  return (
    await instance.patch(`/portal/v1/users/change_password`, {
      password: oldPassword,
      new_password: newPassword
    })
  ).data;
};

export default api;
